
import React from "react";
import { ChatMessage } from "@/components/chat/ChatMessage";
import { ChatInput } from "@/components/chat/ChatInput";
import { ScrollArea } from "@/components/ui/scroll-area";
import type { Agent } from "@/types/agent";
import { Attachment } from "@/components/chat/ChatMessages";

interface ChatPanelProps {
  messages: Array<{
    sender: "user" | "ai";
    text: string;
    timestamp: string;
  }>;
  chatInput: string;
  setChatInput: (value: string) => void;
  handleSendMessage: (attachments?: Attachment[]) => void;
  selectedAgent: Agent | null;
}

export const ChatPanel = ({
  messages,
  chatInput,
  setChatInput,
  handleSendMessage,
  selectedAgent,
}: ChatPanelProps) => {
  // Usar um companyId vazio para o ChatPanel pois é apenas demonstrativo
  const companyId = "";
  
  return (
    <div className="flex flex-col h-full">
      <ScrollArea className="flex-1 p-4">
        <div className="space-y-4">
          {messages.map((message, index) => (
            <ChatMessage key={index} {...message} />
          ))}
        </div>
      </ScrollArea>
      <div className="p-4 border-t">
        <ChatInput
          value={chatInput}
          onChange={setChatInput}
          onSend={handleSendMessage}
          companyId={companyId}
        />
      </div>
    </div>
  );
};
